// extracted by mini-css-extract-plugin
export default {"overlayDropdown":"style_overlayDropdown__a-U-S","ant-popover":"style_ant-popover__JHqOv"};